import { createEditorApp } from './bootstrap/createEditorApp'
import type { WidgetProps } from './runtime/widgetConfig'
import './style.css'

type PublicCreateOptions = WidgetProps & {
    mount: string | Element
}

export async function create(opts: PublicCreateOptions) {
    if (!opts) throw new Error('PixelWidget.create: options missing')

    const { mount, ...props } = opts

    const mountEl =
        typeof mount === 'string'
            ? document.querySelector(mount)
            : mount

    if (!mountEl) {
        throw new Error(`PixelWidget.create: mount target not found (${String(mount)})`)
    }

    return createEditorApp({
        mountEl,
        props,
    })
}

/** optional alias */
export const mountWidget = create
